import { render, staticRenderFns } from "./visaChargeNP.vue?vue&type=template&id=9ea987a6&scoped=true"
import script from "./visaChargeNP.vue?vue&type=script&lang=js"
export * from "./visaChargeNP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea987a6",
  null
  
)

export default component.exports